export default __webpack_public_path__ + "static/media/register.499cd8a8.jpg";